/**
 * @import { AuditFocusAreaOption, AuditStrictnessOption, AuditFocusArea, AuditStrictness }
 *   from '../entities/AuditSettings.types.js'
 */

/** @type {AuditFocusAreaOption[]} */
export const FOCUS_AREAS = [
  {
    labelKey: 'noteAuditor.focusAreas.missingInformation',
    value: 'missingInformation',
    isDefault: true,
  },
  {
    labelKey: 'noteAuditor.focusAreas.internalInconsistencies',
    value: 'internalInconsistencies',
    isDefault: true,
  },
  {
    labelKey: 'noteAuditor.focusAreas.payorBillingRisk',
    value: 'payorBillingRisk',
    isDefault: true,
  },
  {
    labelKey: 'noteAuditor.focusAreas.dataNarrativeMismatch',
    value: 'dataNarrativeMismatch',
    isDefault: true,
  },
  {
    labelKey: 'noteAuditor.focusAreas.locationModalityInconsistencies',
    value: 'locationModalityInconsistencies',
    isDefault: true,
  },
];

/** @type {AuditStrictnessOption[]} */
export const STRICTNESS_MODES = [
  { value: 'strict', labelKey: 'noteAuditor.strictnessModes.strict', isDefault: false },
  { value: 'balanced', labelKey: 'noteAuditor.strictnessModes.balanced', isDefault: true },
  { value: 'lenient', labelKey: 'noteAuditor.strictnessModes.lenient', isDefault: false },
];

/** @type {AuditFocusArea[]} */
export const DEFAULT_FOCUS_AREAS = FOCUS_AREAS
  .filter((fa) => fa.isDefault)
  .map((fa) => fa.value);

const defaultStrictnessMode = STRICTNESS_MODES.find((m) => m.isDefault);
if (!defaultStrictnessMode) {
  throw new Error('No default strictness mode configured');
}

/** @type {AuditStrictness} */
export const DEFAULT_STRICTNESS_MODE = defaultStrictnessMode.value;
